import Api from './api';

export const getAllAddressByTechnicalTeamIdSelectionModel = async (id) => {
  let data = []
  await Api.get(`/techinicalteamorganizationaddress/technicalteam/${id}/selectionmodel`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
}

export const saveLocationInsertModal = async (payload) => {
  let data = []
  await Api.post('/techinicalteamorganizationaddress/multiple', payload)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
}

export const deleteLocationModal = async (payload) => {
  let data = []
  await Api.post('/techinicalteamorganizationaddress/delete', payload)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
}
